import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./NavBar";
import ScrollToTop from "./ScrollToTop";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";
import { trackLandingPageView } from "@/utils/telemetry";

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    trackLandingPageView(location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <NavBar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Layout;